import { Link } from 'react-router-dom';
import styles from './GiverTerms.module.less';

export const GiverTerms = () => {
    return (
        <div className={styles.giverResponsibility}>
            <ul>
                <li>&#x2022; Telefonummer, e-post og beløp deles med SpareBank 1 for hvitvaskingssjekk ved behov</li>
                <br />
                <li>&#x2022; Som giver har du selv et ansvar for å vurdere om du stoler på innsamler og mottaker</li>
            </ul>
            <br />
            <p>
                Ved å betale aksepterer du Spleis sine{' '}
                <Link to={'/vilkar'} target={'_blank'}>
                    vilkår for bruk
                </Link>{' '}
                og{' '}
                <Link to={'/personvern'} target={'_blank'}>
                    personvernerklæring
                </Link>
            </p>
        </div>
    );
};
